import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";

import Loader from "../../components/NewView/Common/Loader";

const NewsComponent = React.lazy(() =>
  import("../../components/NewView/RootComponents/NewsComponent")
);

const NewsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>Новини Yellow Hub</title>
          <meta
            name="description"
            content="Новини, події та історії спільноти Yellow Hub"
          />
        </Helmet>
        <NewsComponent />
      </Suspense>
    </Fragment>
  );
};

export default NewsPage;
